import { useEffect } from 'react';

const body = document.body;
const CLASS_NAME = 'overflow-hidden';

/**
 * This hook is used to lock the body scroll when a modal is open.
 *
 * @param isModalOpen - The state of the modal.
 */
const useBodyScrollLock = (isModalOpen: boolean) => {
  useEffect(() => {
    const setScroll = (isScrollable: boolean) => {
      if (isScrollable) {
        body.classList.remove(CLASS_NAME);
      } else {
        body.classList.add(CLASS_NAME);
      }
    };

    setScroll(!isModalOpen);

    return () => {
      setScroll(true);
    };
  }, [isModalOpen]);
};

export default useBodyScrollLock;
